export const editCaseModal = {
  extends: '/add-case-modal',
  ModalHeader: {
    title: 'Edit {{ key }} case',
    p: null,
  },
  Flex: {},
  ModalFooter: {
    CheckButton: {},
    IconButton: {
      icon: 'trash outline',
      onClick: async (ev, el, s, ctx) => {
        const text = 'Do you want to remove the case?'

        if (window.confirm(text)) {
          await el.updateDesignSystem(`cases.${s.key}`)
          await el.call('closeRouterModal')
        }
      },
    },
  },
  on: {
    init: (el, s) => {
      const key = s.key || el.call('getLastLocationPath').slice(1)
      const value = el.getDesignSystem('cases')?.[key]
      if (!value || !key) {
        return
      }
      s.update({
        value,
        key,
        oldName: key
      })
    },
    submit: async (e, el, s, ctx) => {
      e.preventDefault()

      await el.bulkUpdateDesignSystem(
        [
          {
            type: 'delete',
            path: ['cases', s.oldName]
          },
          {
            type: 'update',
            path: ['cases', s.key],
            value: s.value
          }
        ],
        'Updated Case'
      )
      const t = setTimeout(async () => {
        await el.updateDesignSystem(`cases.${s.key}`, s.value)
        clearTimeout(t)
      }, 75)

      await el.call('closeRouterModal')
    },
  },
};